import { render, staticRenderFns } from "./PayrollDetailsReport.vue?vue&type=template&id=05567c4a&scoped=true&"
import script from "./PayrollDetailsReport.vue?vue&type=script&lang=ts&"
export * from "./PayrollDetailsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05567c4a",
  null
  
)

export default component.exports